import {
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { OpenModalService } from 'src/app/services/shared/open-modal.service';

/**
 * BorderoPageComponent — small Diakonix sub-modal that asks for the
 * carrier name before generating a borderò.
 *
 * Opened from ordini-da-firmare list when the user clicks
 * "Genera Borderò" in sign-batch mode. Emits the typed carrier
 * name via the `answerSubmitted` event; the parent then calls
 * the API and navigates to /firmare.
 *
 * Phase 1.5 / v2.7.0 — TS cleaned up (Chunk D.4):
 *   • dropped unused `borderForm` (FormGroup never built),
 *   • dropped unused `orders` array (no usages),
 *   • dropped `onYesClick` (legacy alias of close — kept Close
 *     binding only),
 *   • dropped `openOrdersServ` + `Router` injections (never used),
 *   • dropped empty `ngOnInit`,
 *   • switch to inject().
 *
 * Behaviour preserved 1:1: submit emits answerSubmitted, close
 * via openModal.offBordero().
 */
@Component({
  selector: 'app-bordero-page',
  templateUrl: './bordero-page.component.html',
  styleUrls: ['./bordero-page.component.scss'],
  standalone: false,
})


export class BorderoPageComponent {

  public readonly openModal = inject(OpenModalService);

  @Input() openedBorder = false;
  @Output() answerSubmitted = new EventEmitter<string>();

  /** Two-way bound to the courier-name input. */
  answer = '';

  submitForm(): void {
    const value = this.answer?.trim() ?? '';
    if (!value) return;
    this.answerSubmitted.emit(value);
    this.openModal.offBordero();
  }

  close(): void {
    this.openModal.offBordero();
  }
  
}
